import { mxApiClient } from "@shared/api/clients/apiClientFactory";
import { CreateMeterManufacturerPayload, CreateMeterManufacturerResponse, CreateMeterModelPayload, CreateMeterModelResponse, UpdateMeterManufacturerPayload, UpdateMeterManufacturerResponse } from "./types";
import { ApiEndpoints } from "@shared/api/api-endpoints";

export const mxManufacturerApi = {
  getMeterManufacturers: async (params: { remote_utility_id: string }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      'mx',
      'meter/manufacturer',
      (qs) => {
        qs.push('remote_utility_id', params.remote_utility_id);
      }
    );
    const response = await mxApiClient.get(url);
    return response.data;
  },

  getMeterModels: async (params: {
  remote_utility_id: string,
  meter_type?: any,
  searchData?: any,
  manufacturer?: any,
  is_active?: any,
  page?: any,
  limit?: any
}): Promise<any> => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    'mx',
    'meter/model',
    (qs) => {
      qs.push('remote_utility_id', params.remote_utility_id);

      if (params.meter_type.toLowerCase?.() !== 'all') {
        qs.push("meter_type", params.meter_type);
      }

      if (params.searchData) {
        qs.push('search_data', params.searchData);
      }

      if (params.manufacturer && params.manufacturer.toLowerCase?.() !== 'all') {
        qs.push('manufacturer', params.manufacturer);
      }

      if (params.is_active) {
        qs.push('is_active', params.is_active);
      }

      if (params.page) {
        qs.push('page', params.page);
      }

      if (params.limit) {
        qs.push('limit', params.limit);
      }
    }
  );

  const response = await mxApiClient.get(url);
  return response.data;
},


  getMeterModelDetail: async (params: { 
    remote_utility_id: string; 
    meter_model_id: string; 
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      'mx',
      'meter/model/detail',
      (qs) => {
        qs.push('remote_utility_id', params.remote_utility_id);
        qs.push('meter_model_id', params.meter_model_id);
      }
    );
    const response = await mxApiClient.get(url);
    return response.data;
  },

  getMeterModelSummary: async (params: { remote_utility_id: string }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      'mx',
      'meter/model/summary',
      (qs) => {
        qs.push('remote_utility_id', params.remote_utility_id);
      }
    );
    const response = await mxApiClient.get(url);
    return response.data;
  },

  // POST APIs
  createMeterManufacturer: async (payload: CreateMeterManufacturerPayload): Promise<CreateMeterManufacturerResponse> => {
    const url = ApiEndpoints.createUrl('mx', 'meter/manufacturer');
    const response = await mxApiClient.post(url, payload);
    return response.data;
  },

  createMeterModel: async (payload: CreateMeterModelPayload): Promise<CreateMeterModelResponse> => {
    const url = ApiEndpoints.createUrl('mx', 'meter/model');
    const response = await mxApiClient.post(url, payload);
    return response.data;
  },

  // PUT API
  updateMeterManufacturer: async (manufacturerId: string, payload: UpdateMeterManufacturerPayload): Promise<UpdateMeterManufacturerResponse> => {
    const url = ApiEndpoints.createUrlWithPathVariables('mx', 'meter/manufacturer', [manufacturerId]);
    const response = await mxApiClient.put(url, payload);
    return response.data;
  },

  getMeterType: async (): Promise<any> => {
    const url = ApiEndpoints.createUrl('mx', 'choices/meter_type');
    const response = await mxApiClient.get(url);
    return response.data;
  },

  getManufacturerType: async (params: { remote_utility_id: string, is_dropdown: any }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      'mx',
      'meter/manufacturer',
      (qs) => {
        qs.push('remote_utility_id', params.remote_utility_id);
        qs.push('is_dropdown', params.is_dropdown);
      }
    );
    const response = await mxApiClient.get(url);
    return response.data;
  },

  delete: async (meterModelId: string): Promise<void> => {
    await mxApiClient.delete(
      ApiEndpoints.createUrlWithPathVariables('mx', 'meter/model', [meterModelId])
    );
  },

  getMeterList: async (params: { 
    remote_utility_id: string; 
    meter_model_id: string; 
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      'mx',
      'meter',
      (qs) => {
        qs.push('remote_utility_id', params.remote_utility_id);
        qs.push('meter_model_id', params.meter_model_id);
      }
    );
    const response = await mxApiClient.get(url);
    return response.data;
  },
updateMeterModel: async (meterId: string, payload: CreateMeterModelPayload): Promise<CreateMeterModelResponse> => {
    const url = ApiEndpoints.createUrlWithPathVariables('mx', 'meter/model', [meterId]);
    const response = await mxApiClient.put(url, payload);
    return response.data;
  },
  
};
